import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBackward$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBackward extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c9f8ceced6f6717adc94a9b354e3a08caf569f2e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0b006ffae8eb8d0f294043bafaeb1af327a3b49d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b8b23947792887c1ef4a16f46db2118b51008608', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.28 5.54 10 10.47V6a.49.49 0 0 0-.72-.44l-6.38 5a.5.5 0 0 0 0 .9l6.38 5A.5.5 0 0 0 10 16v-4.47l6.28 4.91A.5.5 0 0 0 17 16V6a.49.49 0 0 0-.72-.46", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-backward", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-backward"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-backward":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBackward$1);
            }
            break;
    } });
}

const CosmosIconBackward = CosmosIconBackward$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBackward, defineCustomElement };
